import React from 'react';
import Draggable from 'react-draggable';
import { Modal, ModalProps } from "reactstrap";

export interface DraggableModalProps extends ModalProps {
    handle: string;
}

const DraggableModal: React.FC<DraggableModalProps> = ({ handle, children, ...modalProps }) => {
    return (
        <Modal
            {...modalProps}
            modalDialog={(dialog: React.ReactElement) => (
                <Draggable handle={handle} scale={0.8}>
                    {dialog}
                </Draggable>
            )}
        >
            {children}
        </Modal>
    );
};

export default DraggableModal;
